import {
  GuessTheOrderActivity,
  GuessWhereActivity,
  GuessWhoActivity,
  FeelingsMatchActivity,
  GuessWhereRound,
  GuessWhoRound,
  FeelingsMatchRound,
} from '@monorepo/shared/src/graph/schema-generated-types-student';

export enum ActivityActionTypes {
  SET_ACTIVITY = 'SET_ACTIVITY',
  SET_CURRENT_ROUND = 'SET_CURRENT_ROUND',
  SET_IS_LAST_ROUND = 'SET_IS_LAST_ROUND',
  SET_IS_ACTIVITY_OVER = 'SET_IS_ACTIVITY_OVER',
  SET_SHOW_AFFIRMATION = 'SET_SHOW_AFFIRMATION',
  SET_SHOW_NEXT_BUTTON = 'SET_SHOW_NEXT_BUTTON',
}

export type ActivityActions =
  | { type: ActivityActionTypes.SET_ACTIVITY; payload: ActivityState['activity'] }
  | { type: ActivityActionTypes.SET_IS_ACTIVITY_OVER; payload: boolean }
  | { type: ActivityActionTypes.SET_SHOW_AFFIRMATION; payload: boolean }
  | { type: ActivityActionTypes.SET_SHOW_NEXT_BUTTON; payload: boolean }
  | {
      type: ActivityActionTypes.SET_CURRENT_ROUND;
      payload: {
        round: number;
        data: GuessWhereRound | GuessWhoRound | FeelingsMatchRound;
      };
    }
  | {
      type: ActivityActionTypes.SET_IS_LAST_ROUND;
      payload: boolean | number;
    };

export type ActivityDispatchMethods = {
  loadNextRound: () => void;
  setIsActivityOver: (isActivityOver: boolean) => void;
  setShowNextButton: (showNextButton: boolean) => void;
};

export type ActivityState = {
  activity: {
    book:
      | GuessTheOrderActivity['book']
      | GuessWhereActivity['book']
      | FeelingsMatchActivity['book']
      | null;
    rounds:
      | GuessWhereActivity['rounds']
      | GuessWhoActivity['rounds']
      | FeelingsMatchActivity['rounds']
      | [];
    scene: GuessWhereActivity['scene'] | null;
    storyElements: GuessTheOrderActivity['storyElements'] | [];
    title:
      | GuessTheOrderActivity['title']
      | GuessWhereActivity['title']
      | GuessWhoActivity['title']
      | FeelingsMatchActivity['title']
      | null;
  };
  currentRound: {
    round: number;
    data:
      | GuessWhereRound
      | GuessWhoRound
      | FeelingsMatchRound
      | { tiles: GuessTheOrderActivity['storyElements'] };
  } | null;
  isLastRound: boolean;
  isActivityOver: boolean;
  showAffirmation: boolean;
  showNextButton: boolean;
};

export type UseActivity = [ActivityState, ActivityDispatchMethods];
